import { FC, SyntheticEvent, useEffect, useState } from 'react';
import { useFormContext } from '../../../../../contexts/FormContext';
import { useOutputAreaContext } from '../../../../../contexts/OuputAreaContext';
import { GeneratedResponse } from '../../../../../types/FormTypes';
import Markdown from 'markdown-to-jsx';
import styles from './OutputTextarea.module.css';
import { RevisePopup } from './RevisePopup';
import { marked } from 'marked';

export const OutputTextarea: FC = () => {
  const { editedOutput, setEditedOutput } = useFormContext();

  const {
    editTextSelected,
    setEditTextSelected,
    setTextareaScrolloffset,
    setRevisePopupPosition,
  } = useOutputAreaContext();

  const [markdownText, setMarkdownText] = useState('');

  const createMarkup = () => ({ __html: marked(markdownText) });

  // Custom H1 component that adds a '#' at the beginning
  const CustomH1: React.FC<{ children: string }> = ({ children, ...props }) => (
    <b {...props}>#{children}</b>
  );

  const CustomMarkdown: React.FC<{ children: string }> = ({ children }) => {
    return (
      <Markdown
        options={{
          overrides: {
            h1: {
              component: CustomH1,
            },
          },
        }}
      >
        {children}
      </Markdown>
    );
  };

  const monitorClickLocation = (e: MouseEvent) => {
    const outputTextarea = document.getElementById(
      'output-textarea'
    ) as HTMLTextAreaElement;
    const reviseOutputButton = document.getElementById(
      'revise-output-button'
    ) as HTMLButtonElement;
    const clickInTextarea = outputTextarea?.contains(e.target as Node);
    const clickInReviseButton = reviseOutputButton?.contains(e.target as Node);
    if (!clickInTextarea && !clickInReviseButton) {
      // setEditTextSelected(undefined);
    } else if (clickInReviseButton && editTextSelected) {
      outputTextarea.focus();
      outputTextarea.setSelectionRange(
        editTextSelected.start,
        editTextSelected.end
      );
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('click', monitorClickLocation);
      return () => window.removeEventListener('click', monitorClickLocation);
    }
  }, [editTextSelected]);

  function monitorTextareaScroll(this: HTMLTextAreaElement) {
    setTextareaScrolloffset(this.scrollTop);
  }

  useEffect(() => {
    const outputTextarea = document.getElementById('output-textarea');
    if (outputTextarea) {
      outputTextarea.addEventListener('scroll', monitorTextareaScroll);
      return () => {
        outputTextarea.removeEventListener('scroll', monitorTextareaScroll);
        setTextareaScrolloffset(0);
      };
    }
  }, [editedOutput]);

  const monitorTextareaSelect = (
    e: SyntheticEvent<HTMLTextAreaElement, Event>
  ) => {
    const target = e.target as HTMLTextAreaElement;
    const { selectionStart, selectionEnd } = target;

    if (selectionStart === selectionEnd) {
      setEditTextSelected(undefined);
    } else {
      setEditTextSelected({
        // start: selectionStart,
        // end: selectionEnd,
        start: Math.min(selectionStart, selectionEnd),
        end: Math.max(selectionStart, selectionEnd),
      });
      getCursorXY();
    }
  };

  function convertNewlines(text: string) {
    return text.replace(/\n/g, '\n\n');
  }

  const getCursorXY = () => {
    const outputTextarea = document.getElementById(
      'output-textarea'
    ) as HTMLTextAreaElement;
    const outputTextareaContainer = document.getElementById(
      'output-textarea-container'
    ) as HTMLDivElement;
    if (!outputTextarea || !outputTextareaContainer) return;
    // create a dummy div that will be a clone of the textarea
    const dummyTextareaDiv = document.createElement('div');
    dummyTextareaDiv.className = styles['textarea'];
    dummyTextareaDiv.style.position = 'absolute';
    dummyTextareaDiv.style.top = '0px';
    dummyTextareaDiv.style.left = '0px';
    dummyTextareaDiv.style.visibility = 'hidden';
    // dummyTextareaDiv.style.backgroundColor = 'pink';
    // create a dummy paragraph that will represent the text in the textarea
    const dummyTextareaParagraph = document.createElement('p');
    dummyTextareaParagraph.style.display = 'inline';
    dummyTextareaParagraph.textContent = outputTextarea.value.substring(
      0,
      outputTextarea.selectionEnd
    );
    dummyTextareaDiv.appendChild(dummyTextareaParagraph);
    const dummyTextareaSpan = document.createElement('span');
    dummyTextareaDiv.appendChild(dummyTextareaSpan);
    outputTextareaContainer.appendChild(dummyTextareaDiv);
    const { offsetLeft, offsetTop } = dummyTextareaSpan;

    setRevisePopupPosition({
      x: offsetLeft,
      y: offsetTop,
    });
    setTimeout(() => {
      outputTextareaContainer.removeChild(dummyTextareaDiv);
    }, 0);
  };

  return (
    <div id="output-textarea-container" className={styles['container']}>
      <div className={styles['textarea']} id="output-textarea">
        <CustomMarkdown>
          {convertNewlines(editedOutput[0]?.text || '')}
        </CustomMarkdown>
      </div>
      {/* <textarea
        id="output-textarea"
        placeholder="Your copy will be generated here..."
        value={<Markdown>{ editedOutput[0]?.text }</Markdown>|| ''}
        onSelect={monitorTextareaSelect}
        onChange={(e) => {
          const newEditedOutput: GeneratedResponse[] = editedOutput;
          newEditedOutput[0] = {
            text: e.target.value,
            canKeepGoing: newEditedOutput[0]?.canKeepGoing,
          };
          setEditedOutput([...newEditedOutput]);
        }}
        className={styles['textarea']}
      /> */}
      {/* <textarea
        id="input-textarea"
        placeholder="Enter your markdown here..."
        value={markdownText}
        onChange={(e) => setMarkdownText(e.target.value)}
        className={styles.textarea}
      />
      <div
        id="output-div"
        className={`${styles.textarea} ${styles.markdownPreview}`}
        contentEditable={true}
        onInput={(e) => setMarkdownText(e.currentTarget.textContent || '')}
        dangerouslySetInnerHTML={createMarkup()}
      /> */}
      <RevisePopup />
      <p className={styles['character-counter']}>
        {editedOutput[0]?.text.length}
      </p>
    </div>
  );
};
